import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { useNativeSetup } from "@/hooks/useNativeSetup";
import AppLayout from "@/layouts/AppLayout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Landing from "@/pages/Landing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Home from "@/pages/Home";
import Reading from "@/pages/Reading";
import Learn from "@/pages/Learn";
import Review from "@/pages/Review";
import Recite from "@/pages/Recite";
import Progress from "@/pages/Progress";
import Dashboard from "@/pages/Dashboard";
import Teacher from "@/pages/Teacher";
import Parent from "@/pages/Parent";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";

function App() {
  useNativeSetup();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/cgu" element={<Terms />} />
            <Route path="/confidentialite" element={<Privacy />} />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/accueil" element={<Home />} />
              <Route path="/lecture" element={<Reading />} />
              <Route path="/apprendre" element={<Learn />} />
              <Route path="/reviser" element={<Review />} />
              <Route path="/reciter" element={<Recite />} />
              <Route path="/progression" element={<Progress />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/prof" element={<ProtectedRoute roles={["teacher", "admin"]}><Teacher /></ProtectedRoute>} />
              <Route path="/parent" element={<Parent />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/parametres" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
